import cx from 'classnames'
import type { ReactNode } from 'react'

import type { SupportedCurrencies } from 'types/currencies'

import classes from './styles.module.scss'
import Volatility from './VolatilityIndicator'

type Props = {
  volatilityValue: number
  activeCurrency: SupportedCurrencies
  isLoggedIn?: boolean
  isDarkMode?: boolean
  children?: ReactNode
  title: string
  captionClassName: string
  isGameDescription?: boolean
}

function VolatilityContainer({
  children,
  volatilityValue,
  activeCurrency,
  isLoggedIn,
  captionClassName,
  isDarkMode,
  title,
  isGameDescription,
}: Props) {
  return (
    <>
      <span className={cx('mt-typography-caption', classes[captionClassName], isDarkMode && classes.captionDarkMode)}>
        <span className={!isGameDescription && classes.captionText}>{title}</span>
        {children}
      </span>
      <Volatility rating={volatilityValue} max={3} activeCurrency={activeCurrency} isLoggedIn={isLoggedIn} />
    </>
  )
}

export default VolatilityContainer
